import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Icons } from '@/icons/icons'
import { ActionName } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import LfActionsBarComponent from '@/components/ActionsBar/LfActionsBarComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import LfRequiredFieldsLegendComponent from '@/components/forms/fields/LfRequiredFiedsLegend/LfRequiredFiedsLegendComponent.vue'
import FormGeneratorComponent from '@/components/forms/FormGenerator/FormGeneratorComponent.vue'
import store from '@/store/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'PromptDialogComponent',
  props: {
  width: {
    type: Number,
    default: 352
  },
  title: {
    type: String,
    required: true
  },
  hideOverlay: {
    type: Boolean,
    default: false
  },
  subTitle: {
    type: String,
    default: ''
  },
  context: {
    type: String,
    required: true
  },
  isOpened: {
    type: Boolean,
    default: false
  },
  showActionButtons: {
    type: Boolean,
    default: true
  },
  transition: {
    type: String,
    default: ''
  },
  formSchema: {
    type: Array,
    required: true,
    default: () => []
  },
  formFieldValues: {
    type: Object,
    default: () => ({})
  },
  texts: {
    type: Object,
    default: () => ({
      closeButton: 'Cancelar',
      saveButton: 'Guardar'
    })
  },
  showRequiredFieldsAdvice: {
    type: Boolean,
    default: true
  },
  parentField: {
    type: String,
    default: ''
  }
},
  emits: ['execute-action', 'changeFormField'],
  setup(__props, { emit }) {

const props = __props;





const executeAction = (value: string) => {
  emit('execute-action', value)
}

const buttons = computed(() => [
  {
    icon: Icons.CLOSE,
    tooltip: props.texts.closeButton,
    class: 'secondary-color',
    action: ActionName.CLOSE,
    variant: LabelButtonVariant.OUTLINED,
    enabled: true
  },
  {
    icon: Icons.CHECK,
    tooltip: props.texts.saveButton,
    class: 'main-color',
    action: ActionName.SAVE,
    enabled: store.getters[`${ModuleNamespaces.FORMS}/checkIfFormIsValid`](props.context)
  }
])

const dialogProps = computed(() => {
  return {
    width: props.width,
    title: props.title,
    'hide-overlay': props.hideOverlay
  }
})

const onSaveFormData = (schema: any[], formData: object, field: any, value: any) => {
  emit('changeFormField', schema, formData, field, value)
}

return { __sfc: true,props, emit, executeAction, buttons, dialogProps, onSaveFormData, LfActionsBarComponent, LfRequiredFieldsLegendComponent, FormGeneratorComponent }
}

})